import { type DrillType, isWordDrillKind } from "@-/dev.improve.haniverse.lib.drill.entities";

/** A drill whose card is a single GRAPHEME: its meaning or one of its readings. */
export type GraphemeDrillType = Extract<DrillType, { kind: "meaning" | "pronunciation" }>;

/** A drill whose card is a WORD (`user_word_sentence_card`), presented through a sentence. */
export type WordDrillType = Exclude<DrillType, GraphemeDrillType>;

/**
 * Narrows a drill type to its branch. Delegates to `isWordDrillKind` — the SAME predicate the
 * drill page navigator's prefetch list branches on — so the two cannot drift.
 */
export function isWordDrillType(drillType: DrillType): drillType is WordDrillType {
  return isWordDrillKind(drillType.kind);
}
